import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // Este es el único Router que debes usar
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// usuarios a bloquear
const blockedUsers = [16, 17, 18, 2015];

try {
  const userStorage = localStorage.getItem("user");

  if (userStorage) {
    const user = JSON.parse(userStorage);

    if (blockedUsers.includes(user.user_id)) {
      console.log("Usuario bloqueado:", user.user_id);
      localStorage.clear();
    }
  }
} catch (error) {
  console.error("Error leyendo storage:", error);
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <BrowserRouter> {/* Solo un BrowserRouter en toda la app */}
      <App />
    </BrowserRouter>
);

reportWebVitals();